$(document).ready(function() {
    function fixMenu() {
        var topHeaderHeight = $('#top-header').outerHeight(true);
        var menuHeight = $('#bottom-header').outerHeight(true);

        if ($(window).scrollTop() >= topHeaderHeight+10) {
            $('#bottom-header').addClass('fixed');
            // $('.content').css('margin-top', (menuHeight) + 'px');
        } else {
            $('#bottom-header').removeClass('fixed');
            // $('.content').css('margin-top', '0');
        }
    }

    fixMenu();

    $(window).scroll(function() {
        fixMenu();
    });

});


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/fix-menu.js